import type { Locale } from "date-fns";
import { cs } from "date-fns/locale";

import i18n from "@/i18n";

/**
 * Locale-aware formatting helpers driven by the current UI language.
 *
 * These read `i18n.language` at call time, so a component rendering
 * locale-formatted output must subscribe to language changes by calling
 * `useTranslation()` (even if it never uses `t`), or it will keep the
 * old format until its next render.
 */

const BCP47: Record<string, string> = { cs: "cs-CZ", en: "en-US" };

/** BCP-47 tag for the active UI language ("cs" -> "cs-CZ", "en" -> "en-US"). */
export function currentBcp47(): string {
  return BCP47[i18n.language] ?? "en-US";
}

/** date-fns Locale for the active UI language; undefined = built-in en-US. */
export function currentDateFnsLocale(): Locale | undefined {
  return i18n.language === "cs" ? cs : undefined;
}

export function formatDate(date: Date): string {
  return date.toLocaleDateString(currentBcp47());
}

export function formatDateTime(date: Date): string {
  return date.toLocaleString(currentBcp47());
}
